//제목 목록, 데이터 목록 배열, 각각의 width 인자로 받아서 띄워주기
import styled from "styled-components";
import { useEffect, useState } from "react";
import { ReactComponent as CheckShape } from "assets/icons/icon-check-shape.svg";

const CheckboxWithData = ({
  data,
  defaultSelected,
  onClick,
  code,
  backgroundColor,
}) => {
  const [isSelected, setIsSelected] = useState(defaultSelected);
  return (
    <CheckboxContainer>
      <CheckboxArea
        onClick={() => {
          setIsSelected(!isSelected);
          if (onClick) onClick(code, data, !isSelected);
        }}>
        <CheckboxCheckArea>
          {isSelected ? (
            <CheckboxCheckUnselected>
              <CheckShape />
            </CheckboxCheckUnselected>
          ) : (
            <CheckboxCheck backgroundColor={backgroundColor}></CheckboxCheck>
          )}
        </CheckboxCheckArea>
        <CheckboxTextArea>{data}</CheckboxTextArea>
      </CheckboxArea>
    </CheckboxContainer>
  );
};

const OnlyCheckbox = ({ defaultSelected, onClick, backgroundColor }) => {
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(defaultSelected);
  }, [defaultSelected]);

  return (
    <CheckboxContainer>
      <OnlyCheckboxCheckArea
        onClick={() => {
          setIsSelected(!isSelected);
          if (onClick) onClick(!isSelected);
        }}>
        {/* if (onClick) onClick(isSelected);
        }}> */}
        {isSelected ? (
          <CheckboxCheckUnselected>
            <CheckShape />
          </CheckboxCheckUnselected>
        ) : (
          <CheckboxCheck backgroundColor={backgroundColor}></CheckboxCheck>
        )}
      </OnlyCheckboxCheckArea>
    </CheckboxContainer>
  );
};

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;

  margin: 7px 0 7px 0;

  width: 100%;
  height: 3rem;
  min-height: 3rem;
`;

const CheckboxArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  border: var(--border-width) solid var(--Gray);
  border-radius: var(--border-radius-8);
`;

const CheckboxCheckArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10%;
  height: 100%;
`;

const OnlyCheckboxCheckArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CheckboxCheck = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  ${({ backgroundColor }) =>
    backgroundColor && `background-color: ${backgroundColor};`}
  border: var(--border-width) solid var(--Gray);
  border-radius: var(--border-radius-8);
`;

const CheckboxCheckUnselected = styled(CheckboxCheck)`
  background-color: var(--Blue);
`;

const CheckboxTextArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 90%;
  height: 100%;

  font-size: var(--font-size-16);
  font-weight: var(--font-weight-normal);
`;

export { CheckboxWithData, OnlyCheckbox };
